module.exports = __webpack_public_path__ + "img/iconecheckboxavalize.8243b902.png";